import { React } from 'react'
import './css/mode.css'
export default function Mode({ theme, setTheme }) {
    function toggleTheme() {
        var root = document.querySelector(':root');
        if (theme !== "Dark") {
            setTheme("Dark")
            root.style.setProperty('--text', 'white');
            root.style.setProperty('--light', '#282c34');
            root.style.setProperty('--dark', 'white')
        }
        else {
            setTheme("Light")
            root.style.setProperty('--text', 'rgb(53, 53, 53)');
            root.style.setProperty('--light', 'white');
            root.style.setProperty('--dark', '#282c34')

        }
    }
    if (theme === "Dark") {
        return (

            <button title='light mode' onClick={toggleTheme} className='toggle'><span className='material-symbols-outlined'>light_mode</span></button>
        )
    }
    else {
        return (

            <button title='dark mode' onClick={toggleTheme} className='toggle'><span className='material-symbols-outlined'>dark_mode</span></button>
        )
    }
}
